import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';

/**
 * Ruta /chat/:id de las notificaciones (campana y push): el chat vive en el panel lateral, así que
 * no hay página. Pide abrir esa conversación y deja al usuario donde estaba (o en el dashboard si
 * la app se abrió desde la notificación).
 */
export const openChatGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const sessionId = Number(route.paramMap.get('id'));
    if (sessionId > 0) {
        inject(QuickChatService).requestOpen(sessionId);
    }
    const current = router.url;
    return router.parseUrl(current && current !== '/' && !current.startsWith('/chat/') ? current : '/dashboard');
};
